export const GET_TOPICS = `query Topics(
  $tenant_id: Int!,
  $filter: FilterTopicInput,
  $exhibitor_id: Int,
  $orderBy: TopicOrderInput,
  $skip: Int,
  $take: Int
) {
  topics(
    tenant_id: $tenant_id,
    filter: $filter,
    exhibitor_id: $exhibitor_id,
    orderBy: $orderBy,
    skip: $skip,
    take: $take
  ) {
    __typename
    ... on Topic {
      id
      title
      description
      category_id
      subcategory_id
      materials
      video_link
      presentation_file
      active
      its
      uts
      dts
      created_by
      updated_by
      deleted_by
      exhibitor {
        id
        type
        contact {
          id
          firstname
          lastname
        }
      }
      category {
        id
        name
        is_active
      }
      subcategory {
        id
        name
        is_active
      }
    }
    ... on ResultError {
      status_code
      message
    }
  }
}`;

export const TOPICS_COUNT = `query topicsCount(
  $tenant_id: Int!,
  $filter: FilterTopicInput,
  $exhibitor_id: Int
) {
  topicsCount(
    tenant_id: $tenant_id,
    filter: $filter,
    exhibitor_id: $exhibitor_id
  ) {
    __typename
    ... on Count {
      count
    }
    ... on ResultError {
      status_code
      message
      message_translation_key
    }
  }
}`;

export const GET_TOPIC = `query Topic(
  $tenant_id: Int!,
  $id: Int!
) {
  topic(
    tenant_id: $tenant_id,
    id: $id
  ) {
    __typename
    ... on Topic {
      id
      title
      description
      category_id
      subcategory_id
      materials
      video_link
      presentation_file
      active
      its
      uts
      dts
      created_by
      updated_by
      deleted_by
      exhibitor {
        id
        type
        contact {
          id
          firstname
          lastname
        }
      }
      category {
        id
        name
        is_active
      }
      subcategory {
        id
        name
        is_active
      }
    }
    ... on ResultError {
      status_code
      message
    }
  }
}`;

export const GET_EXHIBITION_CATEGORIES = `query ExhibitionCategories(
  $tenant_id: Int!,
  $filter: FilterExhibitionCategoryInput
) {
  exhibitionCategories(
    tenant_id: $tenant_id,
    filter: $filter
  ) {
    __typename
    ... on ExhibitionCategory {
      id
      name
      is_active
    }
    ... on ResultError {
      status_code
      message
    }
  }
}`;

export const GET_EXHIBITION_SUBCATEGORIES = `query ExhibitionSubcategories(
  $tenant_id: Int!,
  $filter: FilterExhibitionSubcategoryInput
) {
  exhibitionSubcategories(
    tenant_id: $tenant_id,
    filter: $filter
  ) {
    __typename
    ... on ExhibitionSubcategory {
      id
      name
      is_active
      exhibition_category_id
    }
    ... on ResultError {
      status_code
      message
    }
  }
}`;

export const GET_EXHIBITORS = `query Exhibitors(
  $tenant_id: Int!,
  $filter: ExhibitorFilterInput
) {
  exhibitors(
    tenant_id: $tenant_id,
    filter: $filter
  ) {
    __typename
    ... on Exhibitor {
      id
      type
      contact {
        id
        firstname
        lastname
      }
    }
    ... on ResultError {
      status_code
      message
    }
  }
}`;

export const TOPIC_PRESENTATION_FILE_DOWNLOAD_URL = `query TopicPresentationFileDownloadUrl(
  $tenant_id: Int!,
  $id: Int!
) {
  topicPresentationFileDownloadUrl(
    tenant_id: $tenant_id,
    id: $id
  )
}`;
